import { memo } from "react";
import { TanStackTable } from "~/common/components/Table/TanStackTable";
import styled from "@emotion/styled";
import { theme } from "~/app/theme";

export const NewOrderBookTable = styled(memo(TanStackTable))(({ theme: _theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderBottom: `none !important`,
  borderRadius: `12px 12px 0 0`,
  overflow: "clip",

  table: {
    borderCollapse: "separate",
  },
  thead: {
    background: `${theme.palette.surface.main} !important`,
  },
  ["tbody > .evenRow > td"]: {
    background: `${theme.palette.surface.bright} !important`,
  },
  td: {
    padding: "8px !important",
    borderTop: `none !important`,
    ["&:last-child"]: {
      borderRight: `none !important`,
    },
    wordBreak: "break-word",
  },
  th: {
    verticalAlign: "top",
    borderTop: `none !important`,
    borderBottom: `2px solid ${theme.palette.divider} !important`,
    paddingLeft: `8px !important;`,

    ["&:last-child"]: {
      borderRight: `none !important`,
    },
  },

  button: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "initial",
    color: `${theme.palette.text.primary} !important`,
    "& svg": {
      fontSize: 20,
    },
  },

  [".scroll-slider__root"]: {
    borderRadius: `12px 12px 0 0`,
    backgroundColor: theme.palette.surface.main,
  },

  ['&[data-stuck="true"] .scroll-slider__root']: {
    borderRadius: 0,
  },

  ".action-cell": {
    opacity: 0,
    transition: "opacity 0.2s ease",
  },

  "tbody tr:hover .action-cell": {
    opacity: 1,
  },
})) as typeof TanStackTable;
